<template>
	<div class="company_detail">
		<div class="base_info d-flex flex-column j-sb a-center">
			<header class="w-100 d-flex j-sb a-center" style="margin-bottom: 1.6rem;">
				<div class="d-flex j-center a-center">
					<img src="../../assets/distributors/biaoqian@2x.png" style="width: 0.94rem; height: 1.13rem;margin-right: 0.28rem;">
					<span style="font-size: 1rem;font-weight: 700;">分公司基本信息</span>
				</div>
				<div class="d-flex j-center a-center">
					<router-link style="color: #BBBBBB;font-size: 0.75rem;" :to="{name:'more_detail',params:{id:agent_id}}" v-slot="{ href, route, navigate, isActive, isExactActive }"
					 custom>
						<a :href="href" class="d-flex j-center a-center" style="text-decoration: none;">
							<span>查看详细信息</span>
							<img src="@/assets/Home/kanquanbu@2x.png" style="width: 0.58rem;height: 0.58rem;">
						</a>
					</router-link>
				</div>
			</header>
			<content class="flex-1 w-100 d-flex j-start a-start">
				<div class="icon" style="width: 5.63rem;height: 5.63rem; border-radius: 50%; border: 4px solid #FFFFFF;box-sizing: border-box;
					box-shadow: 0px 10px 9px 0px rgba(30, 105, 255, 0.3), 0px 0px 20px 0px rgba(0, 0, 0, 0.58) inset;margin-right: 1rem;">
				</div>
				<!-- 	<el-avatar src='../../assets/distributors/mendiantu@2x.png' style="width: 5.63rem;height"></el-avatar> -->
				<div class="h-100 d-flex flex-column j-sb a-start" style="font-size: 0.75rem;color: #666666;width: 66%;">
					<div class="d-flex j-start a-center">
						<span style="font-size: 1rem;font-weight: 700;color: #000000;">{{compangDetail.agent_name}}</span>
						<div v-if="compangDetail.is_confirm == 0" style="font-size: 0.56rem;color: #FFFFFF;width: 2.9rem;height: 0.94rem;line-height: 0.94rem;text-align: center; background: #FFB400;border-radius: 9px 7px 7px 0;margin-left: 0.38rem;">已关闭</div>
						<div v-else style="font-size: 0.56rem;color: #FFFFFF;width: 2.9rem;height: 0.94rem;line-height: 0.94rem;text-align: center; background: greenyellow;border-radius: 9px 7px 7px 0;margin-left: 0.38rem;">运营中</div>
					</div>
					<span>{{compangDetail.province + '省' + compangDetail.city + '市' + compangDetail.district + compangDetail.stores_address}}</span>
					<span>{{compangDetail.stores_tel}}</span>
					<span>{{compangDetail.seller_name}}</span>
					<div class="w-100 d-flex j-sb a-center" style="color: #000000;font-size: 0.66rem;">
						<div v-if="compangDetail.is_confirm == 1" style="border: 1px solid #000000;height: 1.42rem;line-height: 1.42rem;border-radius: 20px;padding: 0 1.05rem;cursor: pointer;" @click="closeCompany">暂时关闭</div>
						<div v-else style="border: 1px solid #000000;height: 1.42rem;line-height: 1.42rem;border-radius: 20px;padding: 0 1.05rem;cursor: pointer;" @click="openCompany">暂时开启</div>
						<div style="border: 1px solid #000000;height: 1.42rem;line-height: 1.42rem;border-radius: 0.71rem;padding: 0 1.05rem;margin-left: 1.22rem;cursor: pointer;" @click="delCompany">删除分公司</div>
					</div>
				</div>
			</content>
		</div>
		<div class="column d-flex flex-column j-sb a-center">
			<div class="period w-100 d-flex j-sb a-center" style="font-size: 0.56rem;color: #888888;">
				<span v-for="(item,index) in period" :key="index" @click="periodIndex(index)" :class="curIndex==index?'active':''"
				 style="cursor: pointer;">{{item}}</span>
			</div>
			<div class="table" ref="column"></div>
		</div>
		<ul class="tab d-flex j-sb a-center position-relative">
			<header class="d-flex j-start a-center" style="align-self: flex-start;padding: 0.94rem;position: absolute;">
				<img src="../../assets/distributors/biaoqian@2x.png" style="width: 0.94rem; height: 1.13rem;margin-right: 0.28rem;">
				<span style="font-weight: 700; font-size: 1rem;">订单数据</span>
			</header>
			<li class="h-100 d-flex flex-column j-end a-center">
				<span class="number">{{homeData.await_pay}}</span>
				<span class="name">待付款</span>
			</li>
			<li class="h-100 d-flex flex-column j-end a-center">
				<span class="number">{{homeData.await_ship}}</span>
				<span class="name">待发货</span>
			</li>
			<li class="h-100 d-flex flex-column j-end a-center">
				<span class="number">{{homeData.await_pickup}}</span>
				<span class="name">待取货</span>
			</li>
			<li class="h-100 d-flex flex-column j-end a-center">
				<span class="number">{{homeData.await_receiving}}</span>
				<span class="name">待收货</span>
			</li>
			<li class="h-100 d-flex flex-column j-end a-center">
				<span class="number">{{homeData.order_cancelled}}</span>
				<span class="name">已取消</span>
			</li>
			<li class="h-100 d-flex flex-column j-end a-center">
				<span class="number">{{homeData.finished}}</span>
				<span class="name">已完成</span>
			</li>
			<li class="h-100 d-flex flex-column j-end a-center">
				<span class="number">{{homeData.await_comment}}</span>
				<span class="name">待评价</span>
			</li>
			<li class="h-100 d-flex flex-column j-end a-center">
				<span class="number">{{homeData.return_number}}</span>
				<span class="name">退/换售后</span>
			</li>
		</ul>
		<div class="sales_data d-flex flex-column j-start a-start">
			<header class="w-100 d-flex j-sb a-center">
				<div class="d-flex j-start a-center">
					<img src="../../assets/distributors/biaoqian@2x.png" style="width: 0.94rem; height: 1.13rem;margin-right: 0.28rem;">
					<span style="font-weight: 700; font-size: 0.94rem;">销售数据</span>
				</div>
				<span style="font-size: 0.66rem; color: #666666;">{{nowdate}}</span>
			</header>
			<div class="total_volume d-flex j-start a-center" style="margin: 0.8rem 0;">
				<img src="../../assets/distributors/zongxiaojinge@2x.png" style="width: 1.88rem;height: 1.88rem;margin-right: 0.28rem;">
				<div class="h-100 d-flex flex-column j-sb a-start">
					<span style="font-size: 0.56rem;">总成交金额</span>
					<span style="font-size: 0.85rem;line-height: 0.85rem; font-weight: 700;">{{ '￥' + optionsTotal3}}</span>
				</div>
			</div>
			<div class="table flex-1" ref="sales_table" style="width: 28.5rem;"></div>
		</div>
		<div class="census d-flex flex-column j-sb ac-center">
			<header class="w-100 d-flex j-sb a-center">
				<div class="d-flex j-center a-center">
					<img src="../../assets/distributors/biaoqian@2x.png" style="width: 0.94rem; height: 1.13rem;margin-right: 0.28rem;">
					<span style="font-size: 1rem;font-weight: 700;">数据统计</span>
				</div>
			</header>
			<div class="wrap flex-1 d-flex flex-wrap j-sb a-center" style="font-weight: 700;">
				<div class="d-flex j-center a-center" style="width: 50%;font-size: 0.75rem;">
					<img src="../../assets/distributors/jingrichengjiao@2x.png" style="width: 1.88rem;height: 1.88rem;margin-right: 0.2rem;">
					<div class="d-flex flex-column j-sb a-center" style="height: 3.1rem;">
						<span>今日成交量</span>
						<span style="font-size: 0.88rem;font-weight: 700;">{{today_data.sales_volume || 0}}</span>
						<div class="d-flex j-center a-center">
							<span :style="growth_rate.sales_volume== 0 ?'color:#FF9D10':checkUp(growth_rate.sales_volume)==-1?'color:#FF4810':'color:#1AC022'"
							 v-text="growth_rate.sales_volume == 0 ?'持平':growth_rate.sales_volume + '%'"></span>
							<img v-if="growth_rate.sales_volume!= 0"
							:src="checkUp(growth_rate.sales_volume)==-1?require('../../assets/Home/shangjiantou@2x.png'):require('../../assets/Home/xiajiantou@2x.png')"
							 style="width: 0.63rem;height: 0.63rem;">
						</div>
					</div>
				</div>
				<div class="d-flex j-center a-center" style="width: 50%;font-size: 0.75rem;">
					<img src="../../assets/distributors/jingridingdan@2x.png" style="width: 1.88rem;height: 1.88rem;margin-right: 0.2rem;">
					<div class="d-flex flex-column j-sb a-center" style="height: 3.1rem;">
						<span>今日订单量</span>
						<span style="font-size: 0.88rem;font-weight: 700;">{{today_data.order_num || 0}}</span>
						<div class="d-flex j-center a-center">
							<span :style="growth_rate.order_num== 0 ?'color:#FF9D10':checkUp(growth_rate.order_num)==-1?'color:#FF4810':'color:#1AC022'"
							 v-text="growth_rate.order_num == 0 ?'持平':growth_rate.order_num + '%'"></span>
							<img v-if="growth_rate.order_num!= 0"
							:src="checkUp(growth_rate.order_num)==-1?require('../../assets/Home/shangjiantou@2x.png'):require('../../assets/Home/xiajiantou@2x.png')"
							 style="width: 0.63rem;height: 0.63rem;">
						</div>
					</div>
				</div>
				<div class="d-flex j-center a-center" style="width: 50%;font-size: 0.75rem;">
					<img src="../../assets/distributors/jinriliulan@2x.png" style="width: 1.88rem;height: 1.88rem;margin-right: 0.2rem;">
					<div class="d-flex flex-column j-sb a-center" style="height: 3.1rem;">
						<span>今日浏览量</span>
						<span style="font-size: 0.88rem;font-weight: 700;">{{today_data.visit_num || 0}}</span>
						<div class="d-flex j-center a-center">
							<span :style="growth_rate.visit_num== 0 ?'color:#FF9D10':checkUp(growth_rate.visit_num)==-1?'color:#FF4810':'color:#1AC022'"
							 v-text="growth_rate.visit_num == 0 ?'持平':growth_rate.visit_num + '%'"></span>
							<img v-if="growth_rate.visit_num!= 0"
							:src="checkUp(growth_rate.visit_num)==-1?require('../../assets/Home/shangjiantou@2x.png'):require('../../assets/Home/xiajiantou@2x.png')"
							 style="width: 0.63rem;height: 0.63rem;">
						</div>
					</div>
				</div>
				<div class="d-flex j-center a-center" style="width: 50%;font-size: 0.75rem;">
					<img src="../../assets/distributors/jinrikedan@2x.png" style="width: 1.88rem;height: 1.88rem;">
					<div class="d-flex flex-column j-sb a-center" style="height: 3.1rem;">
						<span>今日客单价</span>
						<span style="font-size: 0.88rem;">{{today_data.ke_unit_price || 0}}</span>
						<div class="d-flex j-center a-center">
							<span :style="growth_rate.ke_unit_price== 0 ?'color:#FF9D10':checkUp(growth_rate.ke_unit_price)==-1?'color:#FF4810':'color:#1AC022'"
							 v-text="growth_rate.ke_unit_price == 0 ?'持平':growth_rate.ke_unit_price + '%'"></span>
							<img v-if="growth_rate.ke_unit_price!= 0"
							:src="checkUp(growth_rate.ke_unit_price)==-1?require('../../assets/Home/shangjiantou@2x.png'):require('../../assets/Home/xiajiantou@2x.png')"
							 style="width: 0.63rem;height: 0.63rem;">
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="distribute_item d-flex flex-column j-start a-center">
			<header class="w-100 d-flex j-sb a-center" style="margin-bottom: 1.6rem;">
				<div class="d-flex j-center a-center">
					<img src="../../assets/distributors/biaoqian@2x.png" style="width: 0.94rem; height: 1.13rem;margin-right: 0.28rem;">
					<span style="font-size: 1rem;font-weight: 700;">分销商品概况</span>
				</div>
				<div class="d-flex j-center a-center">
					<router-link style="color: #BBBBBB;font-size: 0.75rem;" :to="{name:'distributor_goods',params:{id:agent_id}}" v-slot="{ href, route, navigate, isActive, isExactActive }"
					 custom>
						<a :href="href" class="d-flex j-center a-center" style="text-decoration: none;">
							<span>查看更多</span>
							<img src="@/assets/Home/kanquanbu@2x.png" style="width: 0.58rem;height: 0.58rem;">
						</a>
					</router-link>
				</div>
			</header>
			<div class="box flex-1 w-100">
				<div class="table h-100 w-100 d-flex flex-column j-start a-sb" style="text-align: center;">
					<div class="d-flex j-sb a-center" style="height: 10%;font-weight: 700;font-size: 0.75rem;">
						<span style="flex: .3;">排名</span>						
						<span style="flex: 1;">商品信息</span>
						<div class="flex-1 d-flex j-center a-center">
							<span style="line-height: 1rem;">销量<span style="font-size: 0.56rem;color: #666666;">(件)</span></span>
						</div>
						<div class="d-flex j-center a-center" style="flex: .5;">
							<span style="line-height: 1rem">成交金额<span style="font-size: 0.56rem;color: #666666;">(元)</span></span>
						</div>
						<div class="d-flex j-center a-center" style="flex: .5;">
							<span style="line-height: 1rem">采购数<span style="font-size: 0.56rem;color: #666666;">(件)</span></span>
						</div>
					</div>
					<div class="row d-flex j-center a-center h-100" v-if="distributorgoods.length == 0">暂无数据</div>
					<div class="row d-flex j-sa a-center" style="font-size: 0.66rem;height: 33.3%;color: #666666;" v-for="(item,index) in distributorgoods"
					 :key="index">
						<div style="flex: .3;">
							<img v-if="item.rank < 4" :src="item.rank==1?require('@/assets/Home/diyi@2x.png'):item.rank==2?require('@/assets/Home/dier@2x.png'):require('@/assets/Home/disan@2x.png')"
							 style="width: 1.41rem;height: 1.41rem; vertical-align: middle;">
							<span v-else>{{item.rank}}</span>
						</div>
						<div style="flex: 1;">
							<div class="wrap d-flex j-center a-center" style="max-width: 16rem;margin: 0 auto;">
								<img :src="item.goods_thumb" style="width: 1.88rem;height: 1.88rem;margin-right: 0.58rem;">
								<span style="text-align: left; overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">{{item.goods_name}}</span>
							</div>
						</div>
						<span class="flex-1">{{item.sale_number}}</span>
						<span style="flex: .5;">{{item.count_price}}</span>
						<span style="flex: .5;">{{item.purchase_volume}}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="sales_GDP">
			<header>
				<div class="d-flex j-start a-center">
					<img src="../../assets/distributors/biaoqian@2x.png" style="width: 0.94rem; height: 1.13rem;margin-right: 0.28rem;">
					<span style="font-weight: 700; font-size: 1rem;">销售占比</span>
				</div>
			</header>
			<div class="table" ref="GDP" style="width: 8.26rem;height: 8.26rem;margin: 0 auto;"></div>
			<div class="d-flex j-sb a-center" style="font-size: 0.75rem;margin: 1rem 0;margin-bottom: 0;">
				<div class="d-flex j-center a-center">
					<div style="width: 0.28rem;height: 0.28rem;background: #FFB400;margin-right: 0.42rem;"></div>
					<span>品牌公司:</span>
				</div>
				<span style="flex: 1;padding-left: 2.1rem;">{{companyName.company_name}}</span>
			</div>
			<div class="d-flex j-sb a-center" style="font-size: 0.75rem;">
				<div class="d-flex j-center a-center">
					<div style="width: 0.28rem;height: 0.28rem;background: #1E69FF;margin-right: 0.42rem;"></div>
					<span>省份公司:</span>
				</div>
				<span style="flex: 1;padding-left: 2.1rem;">{{compangDetail.agent_name}}</span>
			</div>
		</div>
		<div class="branch_company_data d-flex flex-column j-start a-center">
			<header class="w-100 d-flex j-sb a-center" style="margin-bottom: 1.6rem;">
				<div class="d-flex j-center a-center">
					<img src="../../assets/distributors/biaoqian@2x.png" style="width: 0.94rem; height: 1.13rem;margin-right: 0.28rem;">
					<span style="font-size: 1rem;font-weight: 700;">分公司数据</span>
				</div>
				<div class="d-flex j-center a-center">
					<router-link style="color: #BBBBBB;font-size: 0.75rem;" :to="{name:'branch_office',params:{id:agent_id}}" v-slot="{ href, route, navigate, isActive, isExactActive }"
					 custom>
						<a :href="href" class="d-flex j-center a-center" style="text-decoration: none;">
							<span>查看更多</span>
							<img src="@/assets/Home/kanquanbu@2x.png" style="width: 0.58rem;height: 0.58rem;">
						</a>
					</router-link>
				</div>
			</header>
			<div class="box flex-1 w-100">
				<div class="table h-100 w-100 d-flex flex-column j-start a-sb" style="text-align: center;">
					<div class="d-flex j-sb a-center" style="height: 10%;font-weight: 700;font-size: 0.75rem;">
						<span style="flex: .3;">排名</span>
						<span class="flex-1" style="flex: 1;">分公司名称</span>
						<div class="d-flex j-center a-center" style="flex: .5;">
							<span style="line-height: 1rem;">销量<span style="font-size: 0.56rem;color: #666666;">(件)</span></span>
						</div>
						<div class="d-flex j-center a-center" style="flex: .5;">
							<span style="line-height: 1rem">销售额<span style="font-size: 0.56rem;color: #666666;">(元)</span></span>
						</div>
						<div class="d-flex j-center a-center" style="flex: .5;">
							<span style="line-height: 1rem">客流量<span style="font-size: 0.56rem;color: #666666;">(点击)</span></span>
						</div>
						<div class="d-flex j-center a-center" style="flex: .5;">
							<span style="line-height: 1rem">采购数<span style="font-size: 0.56rem;color: #666666;">(件)</span></span>
						</div>
						<div class="d-flex j-center a-center" style="flex: .5;">
							<span style="line-height: 1rem">采购总值<span style="font-size: 0.56rem;color: #666666;">(元)</span></span>
						</div>
					</div>
					<div class="row d-flex j-center a-center h-100" v-if="distributorcompany.length == 0">暂无数据</div>
					<div v-else class="row d-flex j-sa a-center" style="font-size: 0.66rem;height: 33.3%;color: #666666;" v-for="(item,index) in distributorcompany"
					 :key="item.rank">
						<div style="flex: .3;">
							<img v-if="item.rank < 4" :src="item.rank==1?require('@/assets/Home/diyi@2x.png'):item.rank==2?require('@/assets/Home/dier@2x.png'):require('@/assets/Home/disan@2x.png')"
							 style="width: 1.41rem;height: 1.41rem; vertical-align: middle;">
							<span v-else>{{item.rank}}</span>
						</div>
						<div style="flex: 1;">
							<div class="wrap d-flex j-center a-center" style="max-width: 16rem;margin: 0 auto;">
								<!-- <img :src="item.stores_logo" style="width: 1.88rem;height: 1.88rem;margin-right: 0.58rem;"> -->
								<span style="text-align: left; overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">{{item.agent_name}}</span>
							</div>
						</div>
						<span class="flex-1" style="flex: .5;">{{item.order_num}}</span>
						<span class="flex-1" style="flex: .5;">{{item.sales_volume}}</span>
						<span class="flex-1" style="flex: .5;">{{item.visit_num}}</span>
						<span class="flex-1" style="flex: .5;">{{item.purchase_volume}}</span>
						<span style="flex: .5;">{{item.purchase_amount}}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="branch_company d-flex flex-column j-start a-start">
			<header class="w-100 d-flex j-sb a-center" style="margin-bottom: 1.6rem;">
				<div class="d-flex j-center a-center">
					<img src="../../assets/distributors/biaoqian@2x.png" style="width: 0.94rem; height: 1.13rem;margin-right: 0.28rem;">
					<span style="font-size: 1rem;font-weight: 700;">下级分公司</span>
				</div>
				<div class="d-flex j-center a-center">
					<router-link style="color: #BBBBBB;font-size: 0.75rem;" :to="{name:'subordinate_branch',params:{id:agent_id}}" v-slot="{ href, route, navigate, isActive, isExactActive }"
					 custom>
						<a :href="href" class="d-flex j-center a-center" style="text-decoration: none;">
							<span>查看更多</span>
							<img src="@/assets/Home/kanquanbu@2x.png" style="width: 0.58rem;height: 0.58rem;">
						</a>
					</router-link>
				</div>
			</header>
			<ul class="flex-1 d-flex flex-column j-start a-start w-100">
				<div class="d-flex j-center a-center h-100 w-100" v-if="nextCompany.length == 0">暂无数据</div>
				<li style="list-style: none;font-size: 0.66rem;color: #666666;" v-for="(item,index) in nextCompany"
				 :key="index">
					{{item.agent_name}}
				</li>
			</ul>
		</div>
		<div class="shop_data d-flex flex-column j-start a-center">
			<header class="w-100 d-flex j-sb a-center" style="margin-bottom: 1.6rem;">
				<div class="d-flex j-center a-center">
					<img src="../../assets/distributors/biaoqian@2x.png" style="width: 0.94rem; height: 1.13rem;margin-right: 0.28rem;">
					<span style="font-size: 1rem;font-weight: 700;">门店数据</span>
				</div>
				<div class="d-flex j-center a-center">
					<router-link style="color: #BBBBBB;font-size: 0.75rem;" :to="{name:'branch_shop',params:{id:agent_id}}" v-slot="{ href, route, navigate, isActive, isExactActive }"
					 custom>
						<a :href="href" class="d-flex j-center a-center" style="text-decoration: none;">
							<span>查看更多</span>
							<img src="@/assets/Home/kanquanbu@2x.png" style="width: 0.58rem;height: 0.58rem;">
						</a>
					</router-link>
				</div>
			</header>
			<div class="box flex-1 w-100">
				<div class="table h-100 w-100 d-flex flex-column j-start a-sb" style="text-align: center;">
					<div class="d-flex j-sb a-center" style="height: 10%;font-weight: 700;font-size: 0.75rem;">
						<span style="flex: .3;">排名</span>
						<span class="flex-1" style="flex: 1;">店铺名称</span>
						<div class="d-flex j-center a-center" style="flex: .5;">
							<span style="line-height: 1rem;">销量<span style="font-size: 0.56rem;color: #666666;">(件)</span></span>
						</div>
						<div class="d-flex j-center a-center" style="flex: .5;">
							<span style="line-height: 1rem">销售额<span style="font-size: 0.56rem;color: #666666;">(元)</span></span>
						</div>
						<div class="d-flex j-center a-center" style="flex: .5;">
							<span style="line-height: 1rem">客流量<span style="font-size: 0.56rem;color: #666666;">(点击)</span></span>
						</div>
						<div class="d-flex j-center a-center" style="flex: .5;">
							<span style="line-height: 1rem">采购数<span style="font-size: 0.56rem;color: #666666;">(件)</span></span>
						</div>
						<div class="d-flex j-center a-center" style="flex: .5;">
							<span style="line-height: 1rem">采购总值<span style="font-size: 0.56rem;color: #666666;">(元)</span></span>
						</div>
					</div>
					<div class="row d-flex j-center a-center h-100" v-if="distributorshop.length == 0">暂无数据</div>
					<div class="row d-flex j-sa a-center" style="font-size: 0.66rem;height: 33.3%;color: #666666;" v-for="(item,index) in distributorshop"
					 :key="item.rank">
						<div style="flex:.3;">
							<img v-if="item.rank < 4" :src="item.rank==1?require('@/assets/Home/diyi@2x.png'):item.rank==2?require('@/assets/Home/dier@2x.png'):require('@/assets/Home/disan@2x.png')"
							 style="width: 1.41rem;height: 1.41rem; vertical-align: middle;">
							<span v-else>{{item.rank}}</span>
						</div>
						<div style="flex: 1;">
							<div class="wrap d-flex j-center a-center" style="max-width: 16rem;margin: 0 auto;">
								<img :src="item.stores_logo" style="width: 1.88rem;height: 1.88rem;margin-right: 0.58rem;" v-if="item.stores_logo">
								<span style="text-align: left; overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">{{item.agent_name}}</span>
							</div>
						</div>
						<span class="flex-1" style="flex: .5;">{{item.order_num}}</span>
						<span class="flex-1" style="flex: .5;">{{item.sales_volume}}</span>
						<span class="flex-1" style="flex: .5;">{{item.visit_num}}</span>
						<span class="flex-1" style="flex: .5;">{{item.purchase_volume}}</span>
						<span style="flex: .5;">{{item.purchase_amount}}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="branch_shop d-flex flex-column j-start a-start">
			<header class="w-100 d-flex j-sb a-center" style="margin-bottom: 1.6rem;">
				<div class="d-flex j-center a-center">
					<img src="../../assets/distributors/biaoqian@2x.png" style="width: 0.94rem; height: 1.13rem;margin-right: 0.28rem;">
					<span style="font-size: 1rem;font-weight: 700;">下级门店</span>
				</div>
				<div class="d-flex j-center a-center">
					<router-link style="color: #BBBBBB;font-size: 0.75rem;" :to="{name:'subordinate_store',params:{id:agent_id}}" v-slot="{ href, route, navigate, isActive, isExactActive }"
					 custom>
						<a :href="href" class="d-flex j-center a-center" style="text-decoration: none;">
							<span>查看更多</span>
							<img src="@/assets/Home/kanquanbu@2x.png" style="width: 0.58rem;height: 0.58rem;">
						</a>
					</router-link>
				</div>
			</header>
			<ul class="flex-1 d-flex flex-column a-start w-100">
				<div class="d-flex j-center a-center h-100 w-100" v-if="nextShop.length == 0">暂无数据</div>
				<li style="list-style: none;font-size: 0.66rem;color: #666666;" v-for="(item,index) in nextShop"
				 :key="index">
					{{item.agent_name}}
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	export default {
		data() {
			return {
				period: ['近30天', '近3个月', '近6个月'],
				curIndex: 0,
				homeData: '',
				orderByNum: true,
				orderByMoney: false,
				num_isDesc: true,
				money_isDesc: true,
				option1: {
					grid: {
						left: 0,
						right: 0,
						top: 20,
						bottom: 20
					},
					xAxis: {
						type: 'category',
						data: ['成交量(件)', '订单量(元)', '浏览量(次)', '客单价(元)', ],
						nameTextStyle: {
							fontSize: '12px'
						},
						axisTick: {
							show: false
						}
					},
					yAxis: {
						show: false,
						type: 'value'
					},
					series: [{
						// data: ['-', '0.00', '+4.23', '+0.72'],
						type: 'bar',
						stack: 'one',
						itemStyle: {
							color: '#FF5E2D'
						},
						label: {
							show: true,
							position: 'top',
							color: '#FF5E2D',
							formatter: function(params) {
								return `${params.value}%{b|}`
							},
							rich: {
								a: {
									color: '#FF5E2D',
									lineHeight: 10
								},
								b: {
									backgroundColor: {
										image: require('@/assets/distributors/shangsheng@2x.png'),
									},
									height: 10,
									width: 6
								},
							}
						}
					}, {
						// data: ['-1.10', '-', '-', '-'],
						type: 'bar',
						stack: 'one',
						itemStyle: {
							color: '#1AC022'
						},
						label: {
							show: true,
							position: 'top',
							color: '#1AC022',
							formatter: function(params) {
								return `${params.value}%{b|}`
							},
							rich: {
								a: {
									color: '#1AC022',
									lineHeight: 10
								},
								b: {
									backgroundColor: {
										image: require('@/assets/distributors/xiajiang@2x.png'),
									},
									height: 10,
									width: 6
								},
							}
						}
					}]
				},
				option2: {
					tooltip: {
						trigger: 'item'
					},
					series: [{
						name: '访问来源',
						type: 'pie',
						radius: ['50%', '90%'],
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center',
							fontSize: '0.75rem',
							fontWeight: 'bold',
							formatter: `{a|{d}%\n}{b|总占比(%)}`,
							rich: {
								a: {
									color: ['#1E69FF', '#FFB400'],
									lineHeight: 10
								},
								b: {
									color: '#000000',
									lineHeight: 10
								},
							}
						},
						color: ['#1E69FF', '#FFB400'],
						emphasis: {
							label: {
								show: true
							}
						},
						labelLine: {
							show: false
						},
						
					}]
				},
				optionsTotal3 : 0,
				option3: {
					grid: {
						left: 25,
						righ: 20,
						top: 0,
						bottom: 20
					},
					tooltip: {
						trigger: 'item'
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						splitLine: {
							show: false
						},
						axisPointer: {
							show: true,
							lineStyle: {
								color: ['#1E69FF']
							}
						},
						axisLabel: {
							fontSize: '0.65rem'
						}
					},
					yAxis: {
						type: 'value',
						show: false,
						// boundaryGap: [0, '%'],
						axisLabel: {
							show: false
						},
					},
					series: [{
						type: 'line',
						smooth: 0.5,
						itemStyle: {
							width: '10',
							color: '#1E69FF',
							borderColor: '#FFFFFF',
							borderWidth: '4',
						},
						symbolSize: '8',
						lineStyle: {
							color: '#1E69FF',
							width: 3
						},
						areaStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: 'rgb(214, 228, 255)'
							}, {
								offset: 1,
								color: 'rgb(255, 255, 255)'
							}])
						},
						emphasis: {
							itemStyle: {
								color: '#1E69FF',
								borderColor: '#FFFFFF'
							}
						},
						// data: [0,0,0,0,0,0,0]					
					}]
				},
				rank: [{
					rank: 1,
					item: {
						name: 'Gree/格力晶弘 225升电冰箱三开门家用小型宿舍用迷你租房用节能',
						icon: require('@/assets/Home/shangpintupian@2x.png'),
						id: 'DSA45'
					},
					sales_volume: 25369,
					sales_amount: 1236943.22
				}, {
					rank: 2,
					item: {
						name: 'Gree/格力晶弘 225升电冰箱三开门家用小型宿舍用迷你租房用节能',
						icon: require('@/assets/Home/shangpintupian@2x.png'),
						id: 'DSA45'
					},
					sales_volume: 20369,
					sales_amount: 1236943.22
				}, {
					rank: 3,
					item: {
						name: 'Gree/格力晶弘 225升电冰箱三开门家用小型宿舍用迷你租房用节能',
						icon: require('@/assets/Home/shangpintupian@2x.png'),
						id: 'DSA45'
					},
					sales_volume: 11469,
					sales_amount: 1236943.22
				}],
				distributorgoods: [],
				distributorcompany: [],
				distributorshop: [],
				branch_company: [],
				branch_shop: [],
				agent_id : '',
				compangDetail : {},
				nowdate :'',
				growth_rate : {},
				today_data : {},
				companyName : '',
				nextCompany : [],
				nextShop : []
			}
		},
		watch: {
			orderByNum(newValue, oldValue) {
				if (newValue == false) {
					this.num_isDesc = false
				}
			},
			orderByMoney(newValue, oldValue) {
				if (newValue == false) {
					this.money_isDesc = false
				}
			}
		},
		methods: {
			checkUp(data) {
				let status =  (data+'').indexOf('-')
				return status
			},
			nowDate() {
				let date = new Date();
				let month = date.getMonth() + 1
				this.nowdate = date.getFullYear() + '-' + month + '-' +date.getDate()
			},
			closeCompany(){
				if(this.compangDetail.is_confirm == 0){
					this.$message.warning('该分销商已经处于关闭状态')
					return
				}
				let param = {
					act : 'operation_agent_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_ids : this.compangDetail.agent_id,
					ctrl : 'close'
				}
				this.$api.company_list(param).then((res) => {
					if(res.code == 0){
						this.$message.success(res.msg);
						this.compangDetail.is_confirm = 0
					}else{
						this.$message.error(res.msg);
					}
				}).catch((err) => {
					this.$message.error(err);
				})
			},
			openCompany(){
				let param = {
					act : 'operation_agent_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_ids : this.compangDetail.agent_id,
					ctrl : 'open'
				}
				this.$api.company_list(param).then((res) => {
					if(res.code == 0){
						this.$message.success(res.msg);
						this.compangDetail.is_confirm = 1
					}else{
						this.$message.error(res.msg);
					}
				}).catch((err) => {
					this.$message.error(err);
				})
			},
			delCompany(){
				let param = {
					act : 'operation_agent_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_ids : this.compangDetail.agent_id,
					ctrl : 'del'
				}
				this.$api.company_list(param).then((res) => {
					if(res.code == 0){
						this.$message.success(res.msg);
					}else{
						this.$message.error(res.msg);
					}
				}).catch((err) => {
					this.$message.error(err);
				})
			},
			periodIndex(index){
				this.curIndex = index
				if(index == 0){
					this.$api.company_list({
						act:'data_statistics_left',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						agent_id : this.agent_id,
						type : 1
					}).then((res) => {
						if(res.code == 0){
							let optionsData1 = res
							let arr1 = [0,0,0,0]
							let arr2 = [0,0,0,0]
							if(parseFloat(optionsData1.data.sales_volume) >= 0){
								arr1[0] = parseFloat(optionsData1.data.sales_volume)
								arr2[0] = ''
							}else {
								arr1[0] = ''
								arr2[0] = parseFloat(optionsData1.data.sales_volume)
							}
							if(parseFloat(optionsData1.data.order_num) >= 0){
								arr1[1] = parseFloat(optionsData1.data.order_num)
								arr2[1] = ''
							}else {
								arr1[1] = ''
								arr2[1] = parseFloat(optionsData1.data.order_num)
							}
							if(parseFloat(optionsData1.data.visit_num) >= 0){
								arr1[2] = parseFloat(optionsData1.data.visit_num)
								arr2[2] = ''
							}else {
								arr1[2] = ''
								arr2[2] = parseFloat(optionsData1.data.visit_num)
							}
							if(parseFloat(optionsData1.data.ke_unit_price) >= 0){
								arr1[3] = parseFloat(optionsData1.data.ke_unit_price)
								arr2[3] = ''
							}else {
								arr1[3] = ''
								arr2[3] = parseFloat(optionsData1.data.ke_unit_price)
							}
							this.option1.series[0].data = arr1
							this.option1.series[1].data = arr2
							let chartDom1 = this.$refs.column
							let myChart1 = echarts.init(chartDom1)
							this.option1 && myChart1.setOption(this.option1)					
							setTimeout(function() {
								window.onresize = function() {
									myChart1.resize();
								}
							}, 200)
						}else {
							this.option1.series[0].data = ['','','','']
							this.option1.series[1].data = ['','','','']
						}
					})
				}else if(index == 1){
					this.$api.company_list({
						act:'data_statistics_left',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						agent_id : this.agent_id,
						type : 2
					}).then((res) => {
						if(res.code == 0){
							let optionsData1 = res
							let arr1 = [0,0,0,0]
							let arr2 = [0,0,0,0]
							if(parseFloat(optionsData1.data.sales_volume) >= 0){
								arr1[0] = parseFloat(optionsData1.data.sales_volume)
								arr2[0] = ''
							}else {
								arr1[0] = ''
								arr2[0] = parseFloat(optionsData1.data.sales_volume)
							}
							if(parseFloat(optionsData1.data.order_num) >= 0){
								arr1[1] = parseFloat(optionsData1.data.order_num)
								arr2[1] = ''
							}else {
								arr1[1] = ''
								arr2[1] = parseFloat(optionsData1.data.order_num)
							}
							if(parseFloat(optionsData1.data.visit_num) >= 0){
								arr1[2] = parseFloat(optionsData1.data.visit_num)
								arr2[2] = ''
							}else {
								arr1[2] = ''
								arr2[2] = parseFloat(optionsData1.data.visit_num)
							}
							if(parseFloat(optionsData1.data.ke_unit_price) >= 0){
								arr1[3] = parseFloat(optionsData1.data.ke_unit_price)
								arr2[3] = ''
							}else {
								arr1[3] = ''
								arr2[3] = parseFloat(optionsData1.data.ke_unit_price)
							}
							this.option1.series[0].data = arr1
							this.option1.series[1].data = arr2
							let chartDom1 = this.$refs.column
							let myChart1 = echarts.init(chartDom1)
							this.option1 && myChart1.setOption(this.option1)					
							setTimeout(function() {
								window.onresize = function() {
									myChart1.resize();
								}
							}, 200)
						}else {
							this.option1.series[0].data = ['','','','']
							this.option1.series[1].data = ['','','','']
						}
					})
				}else if(index == 2){
					this.$api.company_list({
						act:'data_statistics_left',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						agent_id : this.agent_id,
						type : 3
					}).then((res) => {
						if(res.code == 0){
							let optionsData1 = res
							let arr1 = [0,0,0,0]
							let arr2 = [0,0,0,0]
							if(parseFloat(optionsData1.data.sales_volume) >= 0){
								arr1[0] = parseFloat(optionsData1.data.sales_volume)
								arr2[0] = ''
							}else {
								arr1[0] = ''
								arr2[0] = parseFloat(optionsData1.data.sales_volume)
							}
							if(parseFloat(optionsData1.data.order_num) >= 0){
								arr1[1] = parseFloat(optionsData1.data.order_num)
								arr2[1] = ''
							}else {
								arr1[1] = ''
								arr2[1] = parseFloat(optionsData1.data.order_num)
							}
							if(parseFloat(optionsData1.data.visit_num) >= 0){
								arr1[2] = parseFloat(optionsData1.data.visit_num)
								arr2[2] = ''
							}else {
								arr1[2] = ''
								arr2[2] = parseFloat(optionsData1.data.visit_num)
							}
							if(parseFloat(optionsData1.data.ke_unit_price) >= 0){
								arr1[3] = parseFloat(optionsData1.data.ke_unit_price)
								arr2[3] = ''
							}else {
								arr1[3] = ''
								arr2[3] = parseFloat(optionsData1.data.ke_unit_price)
							}
							this.option1.series[0].data = arr1
							this.option1.series[1].data = arr2
							let chartDom1 = this.$refs.column
							let myChart1 = echarts.init(chartDom1)
							this.option1 && myChart1.setOption(this.option1)					
							setTimeout(function() {
								window.onresize = function() {
									myChart1.resize();
								}
							}, 200)
						}else {
							this.option1.series[0].data = ['','','','']
							this.option1.series[1].data = ['','','','']
						}
					})
				}				
			},
			dataStatisticsRight(){
				let param = {
					act : 'data_statistics_right',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_id : this.agent_id,
				}
				this.$api.company_list(param).then((res) => {
					if(res.code == 0){
						this.growth_rate = res.data.growth_rate
						this.today_data = res.data.today_data
					}else {
						
					}
				}).catch((err) => {
					this.$message.error(err);
				})
			},
			getCompanyDetails(){
				let param = {
					act : 'agent_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_id : this.agent_id,
				}
				this.$api.company_list(param).then((res) => {
					if(res.code == 0){
						this.compangDetail = res.data
						this.getDistributorcompany()
						this.getDistributorshop()
					}else {
						this.$message.error('发生错误，请重试');
					}
				}).catch((err) => {
					this.$message.error(err);
				})
			},
			getHomeData() {
				let param = {
					act: 'order_data',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_id : this.agent_id
				}
				this.$api.homeData(param).then((res) => {
					this.homeData = res.data
					localStorage.setItem('homeData', JSON.stringify(res.data))
				})
			},
			initTable(){
				let p1 = this.$api.company_list({
					act:'week_sales_data',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_id : this.agent_id,
				})
				let p2 = this.$api.company_list({
					act:'data_statistics_left',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_id : this.agent_id,
					type : 1
				})
				let p3 = this.$api.company_list({
					act:'sale_proportion',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_id : this.agent_id
				})
				Promise.all([p1,p2,p3]).then((res) => {
					let optionsData3 = res[0]
					if(optionsData3.code == 0){
						this.option3.xAxis.data = optionsData3.data.week_sales_data.dates_data
						this.option3.series[0].data = optionsData3.data.week_sales_data.sales_data.map(Number)
						this.optionsTotal3 = parseFloat(optionsData3.data.count_sales_amount).toFixed(2)
					}else {
						this.$message.warning(optionsData3.msg)
					}
					let optionsData1 = res[1]
					if(optionsData1.code == 0){
						let arr1 = [0,0,0,0]
						let arr2 = [0,0,0,0]
						if(parseFloat(optionsData1.data.sales_volume) >= 0){
							arr1[0] = parseFloat(optionsData1.data.sales_volume)
							arr2[0] = ''
						}else {
							arr1[0] = ''
							arr2[0] = parseFloat(optionsData1.data.sales_volume)
						}
						if(parseFloat(optionsData1.data.order_num) >= 0){
							arr1[1] = parseFloat(optionsData1.data.order_num)
							arr2[1] = ''
						}else {
							arr1[1] = ''
							arr2[1] = parseFloat(optionsData1.data.order_num)
						}
						if(parseFloat(optionsData1.data.visit_num) >= 0){
							arr1[2] = parseFloat(optionsData1.data.visit_num)
							arr2[2] = ''
						}else {
							arr1[2] = ''
							arr2[2] = parseFloat(optionsData1.data.visit_num)
						}
						if(parseFloat(optionsData1.data.ke_unit_price) >= 0){
							arr1[3] = parseFloat(optionsData1.data.ke_unit_price)
							arr2[3] = ''
						}else {
							arr1[3] = ''
							arr2[3] = parseFloat(optionsData1.data.ke_unit_price)
						}
						this.option1.series[0].data = arr1
						this.option1.series[1].data = arr2
					}else {
						this.option1.series[0].data = ['','','','']
						this.option1.series[1].data = ['','','','']
					}
					let optionData2 = res[2]
					let data2 = [{
							value: 0,
							name: ''
						},{
							value: 0,
							name: ''
						}
					]
					if(optionData2.code == 0){
						data2[0].value = optionData2.data
						data2[0].name = this.compangDetail.agent_name
						data2[1].value = 100 - data2[0].value
						data2[1].name = this.companyName.company_name
						this.option2.series[0].data = data2
					}else {
						data2[0].value = optionData2.data
						data2[0].name = this.compangDetail.agent_name
						data2[1].value = 100
						data2[1].name = this.companyName.company_name
						this.option2.series[0].data = data2
					}
					let chartDom1 = this.$refs.column
					let myChart1 = echarts.init(chartDom1)
					this.option1 && myChart1.setOption(this.option1)
					let chartDom2 = this.$refs.GDP					
					let myChart2 = echarts.init(chartDom2)
					this.option2 && myChart2.setOption(this.option2)
					let chartDom3 = this.$refs.sales_table
					let myChart3 = echarts.init(chartDom3)
					console.log(this.option2);
					this.option3 && myChart3.setOption(this.option3)
					
					setTimeout(function() {
						window.onresize = function() {
							myChart1.resize();
							myChart2.resize();
							myChart3.resize();
						}
					}, 200)
				})
			},
			changeSort(type) {
				if (type == 'num') {
					this.orderByNum = true
					this.orderByMoney = false
					this.num_isDesc = !this.num_isDesc
				} else {
					this.orderByNum = false
					this.orderByMoney = true
					this.money_isDesc = !this.money_isDesc
				}
			},
			getNextcompany() {
				let param = {
					act: 'sub_agent_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					data_type : 'company',
					agent_id : this.agent_id,
					page : 1,
					size : 6,
				}
				this.$api.company_list(param).then((res) => {
					if(res.code == 0){
						this.nextCompany = res.data
					}
				})
			},
			getNextshop() {
				let param = {
					act: 'sub_agent_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					data_type : 'store',
					agent_id : this.agent_id,
					page : 1,
					size : 6,
				}
				this.$api.company_list(param).then((res) => {
					if(res.code == 0){
						this.nextShop = res.data
					}
				})
			},
			getDistributorgoods(){
				let param = {
					act: 'company_goods_survey',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_id : this.agent_id,
					sort_field : 'sale_number',
					sort : 'desc',
					type : -1,
					page : 1,
					size : 3
				}
				this.$api.company_list(param).then((res) => {
					if(res.code == 0){
						this.distributorgoods = res.data
						this.distributorgoods.forEach((item,index) => {
							item.rank = index +1
						})
					}
				})
			},
			getDistributorcompany(){
				let param = {
					act: 'sub_agent_data',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_id : this.agent_id,
					rank_id : this.compangDetail.rank_id,
					data_type : 'company',
					sort_field : 'order_num',
					sort : 'desc',
					type : -1,
					page : 1,
					size : 3
				}
				this.$api.company_list(param).then((res) => {
					if(res.code == 0){
						this.distributorcompany = res.data
						this.distributorcompany.forEach((item,index) => {
							item.rank = index +1
						})
					}
				})
			},
			getDistributorshop(){
				let param = {
					act: 'sub_agent_data',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					agent_id : this.agent_id,
					rank_id : this.compangDetail.rank_id,
					data_type : 'store',
					sort_field : 'order_num',
					sort : 'desc',
					type : -1,
					page : 1,
					size : 3
				}
				this.$api.company_list(param).then((res) => {
					if(res.code == 0){
						this.distributorshop = res.data
						this.distributorshop.forEach((item,index) => {
							item.rank = index +1
						})
					}
				})
			}
		},
		mounted() {
			this.agent_id = this.$route.params.id
			this.getCompanyDetails()
			this.getHomeData()
			this.initTable()
			this.nowDate()
			this.dataStatisticsRight()
			this.companyName = JSON.parse(localStorage.getItem('user_info'))
			this.homeData = JSON.parse(localStorage.getItem('homeData'))
			this.getNextcompany()
			this.getNextshop()
			this.getDistributorgoods()
		}

	}
</script>

<style lang="scss" scoped>
	@mixin common {
		background: #FFFFFF;
		border-radius: 6px;
		padding: 1.1rem 0.94rem;
		box-sizing: border-box;
	}

	@mixin table {
		table {
			text-align: center;

			th {
				font-size: 0.77rem;
			}

			tr {

				td {
					margin: 0 2rem;
				}
			}
		}
	}

	.company_detail {
		max-width: 73.24rem;
		margin: 0 auto;
		width: 100%;
		display: grid;
		grid-template-rows: 7.31rem 5.38rem 10.77rem 16.15rem 16.13rem 15.19rem;
		grid-template-columns: 23rem 31.92rem 16.43rem;
		gap: 0.94rem;

		.base_info {
			grid-column: 1;
			grid-row: 1/3;
			@include common;

			.icon {
				background: url(../../assets/distributors/mendiantu@2x.png);
				background-size: 100% 100%;
				background-repeat: no-repeat;
			}
		}

		.column {
			grid-column: 1;
			grid-row: 3/4;
			@include common;

			.period {
				.active {
					color: #000000;
					font-size: 0.75rem;
					font-weight: 700;
				}
			}

			.table {
				width: 100%;
				height: 7rem;
			}
		}


		.tab {
			grid-row: 1/2;
			grid-column: 2/4;
			background: #FFFFFF;
			border-radius: 6px;

			li {
				list-style: none;
				flex: 1;
				padding: 1.17rem 0;
				box-sizing: border-box;
				cursor: pointer;

				.logo {
					width: 1.6rem;
					height: 1.6rem;
				}

				.number {
					font-size: 1.13rem;
					font-weight: 700;
				}

				.name {
					font-size: 0.75rem;
					color: #666666;
					font-weight: bold;
				}

				&:hover {
					background: #E7EFFF;
				}
			}
		}

		.sales_data {
			@include common;
			grid-row: 2/4;
			grid-column: 2/3;
		}

		.census {
			@include common;
			grid-row: 2/4;
			grid-column: 3/4;
		}

		.distribute_item {
			@include common;
			@include table;
			grid-row: 4/5;
			grid-column: 1/3;
		}

		.sales_GDP {
			@include common;
			grid-row: 4/5;
			grid-column: 3/4;
		}

		.branch_company_data {
			@include common;
			@include table;
			grid-row: 5/6;
			grid-column: 1/3;
		}

		.shop_name {
			color: #000000;
			text-decoration: none;
			&:hover{
				text-decoration: underline;
			}
		}

		.branch_company {
			@include common;
			grid-row: 5/6;
			grid-column: 3/4;
		}

		.shop_data {
			@include common;
			@include table;
			grid-row: 6/7;
			grid-column: 1/3;
		}

		.branch_shop {
			@include common;
			grid-row: 6/7;
			grid-column: 3/4;
		}
	}
</style>
